import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import MetaBookingModal from '../../../MetaBooking/modals/MetaBookingModal';
import { useAuthContext } from '../../../../../../context/AuthContext';
import getAbilityForReservation from '../SaveBookingFlow/helpers/getAbilityForReservation';
import SuccessAccordions, {
  ExtendedMetaPredictionsResponse,
} from './SuccessAccordion/SuccessAccordions';
import {
  MetaCampaignData,
  MetaCampaignReservationResult,
} from '../../../../../../api/services/mediaPlanning/bookMeta';

export interface BookingFlowProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onSecondaryAction?: () => void;
  header: string;
  isLoading: boolean;
  error: string | null;
  successData?: MetaCampaignData[];
}

function BookingFlow({
  open,
  onClose,
  onSuccess,
  onSecondaryAction,
  header,
  isLoading,
  error,
  successData,
}: BookingFlowProps) {
  const { userRoles } = useAuthContext();
  const { t } = useTranslation();

  if (getAbilityForReservation(userRoles)) {
    if (isLoading) {
      return (
        <MetaBookingModal
          open={open}
          onClose={onClose}
          onSuccess={onSuccess}
          onSecondaryAction={onSecondaryAction}
          header={t('mediaPlanning.metaBooking.modals.contactingMeta.header')}
          text={t('mediaPlanning.metaBooking.modals.contactingMeta.loading')}
          proceedText={t(
            'mediaPlanning.metaBooking.modals.contactingMeta.proceedText'
          )}
          isLoading={isLoading}
          isBooking
          isInformationalOnly
        />
      );
    }
    if (error) {
      return (
        <MetaBookingModal
          open={open}
          onClose={onClose}
          onSuccess={onSuccess}
          header={t('mediaPlanning.metaBooking.modals.bookingError.header')}
          text={t('mediaPlanning.metaBooking.modals.bookingError.text')}
          proceedText={t(
            'mediaPlanning.metaBooking.modals.bookingError.proceedText'
          )}
          type="error"
          isInformationalOnly
        />
      );
    }
    return (
      <MetaBookingModal
        open={open}
        onClose={onClose}
        onSuccess={onSuccess}
        onSecondaryAction={onSecondaryAction}
        header={t('mediaPlanning.metaBooking.modals.bookingSuccess.header')}
        text={
          <Stack>
            <Typography mb={2}>The META status has been updated</Typography>
            <SuccessAccordions
              isLoading={false}
              isValidityCheck
              pricingData={successData}
            />
          </Stack>
        }
        proceedText={t(
          'mediaPlanning.metaBooking.modals.bookingSuccess.proceedText'
        )}
        isInformationalOnly
      />
    );
  }

  return (
    <MetaBookingModal
      open={open}
      onClose={onClose}
      onSuccess={onSuccess}
      header={t('mediaPlanning.metaBooking.modals.insufficientRights.header')}
      text={t('mediaPlanning.metaBooking.modals.insufficientRights.text')}
      cancelText={t(
        'mediaPlanning.metaBooking.modals.insufficientRights.cancelText'
      )}
      proceedText={t(
        'mediaPlanning.metaBooking.modals.insufficientRights.proceedText'
      )}
    />
  );
}

export default BookingFlow;
